import { MasterDialog } from "#common/Dialog/Dialog"
import { useApiSend } from "#hooks/useApiSend"
import STATUS from "#vacation/constants"
import { UseVacationContext } from "#vacation/contexts/VacationContext"
import { vacationDelete, vacationPut } from "#vacation/services/api"
import { Cancel, CheckCircle } from "@mui/icons-material"
import { Box, Button, Divider, TextField, Typography } from "@mui/material"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider"
import { Fragment, useCallback, useState } from "react"
import { toast } from "react-toastify"
import VacationDetails from "./VacationDetails"

export default function VacationDialogApprove() {
	const { vacation, setOpenApprove, openApprove, refresh } = UseVacationContext()
	const [disabled, setDisabled] = useState(false)

	const success = useCallback(() => {
		refresh()
		setDisabled(false)
		setOpenApprove(false)
	}, [refresh, setDisabled, setOpenApprove])

	const { fetch: fetchPut } = useApiSend(vacationPut, {
		success,
		end: () => setDisabled(false),
	})

	const status = vacation?.status
	const handleApprove = () => {
		setDisabled(true)
		fetchPut(vacation.id, {
			status: STATUS.APPROVE,
		})
	}

	return (
		<MasterDialog
			{...{
				open: openApprove,
				setOpen: setOpenApprove,
				maxWidth: "sm",
				propsChildren: {
					sx: { p: 0 },
				},
			}}
		>
			<LocalizationProvider dateAdapter={AdapterDayjs}>
				<Box sx={{ maxWidth: 1200, mx: "auto" }}>
					<VacationDetails id={vacation.id} />
					<Divider sx={{ my: 3 }} />

					<Box sx={{ display: "flex", gap: 2 }}>
						{status === STATUS.SOLICITADA && (
							<Button
								variant="contained"
								color="success"
								startIcon={<CheckCircle />}
								onClick={handleApprove}
								sx={{ flex: 1 }}
								disabled={disabled}
							>
								Aprobar Solicitud
							</Button>
						)}
						<RejectVacationDialog {...{ success, disabled, setDisabled }} />
					</Box>
				</Box>
			</LocalizationProvider>
		</MasterDialog>
	)
}

const RejectVacationDialog = ({ success, disabled, setDisabled }) => {
	const { vacation } = UseVacationContext()
	const { fetch: fetchDelete } = useApiSend(vacationDelete, {
		success,
		end: () => setDisabled(false),
	})
	const [open, setOpen] = useState(false)
	const [comments, setComments] = useState("")

	const handleReject = () => {
		if (!comments) {
			toast.error("Debe agregar un comentario")
			return
		}
		setDisabled(true)
		fetchDelete(vacation.id, { comments })
		setOpen(false)
	}
	const buttons = [
		{ label: "Cancelar", onClick: () => setOpen(false) },
		{ label: "Rechazar", onClick: handleReject },
	]
	return (
		<Fragment>
			<Button
				variant="contained"
				color="error"
				startIcon={<Cancel />}
				onClick={() => setOpen(true)}
				sx={{ flex: 1 }}
				disabled={disabled}
			>
				Rechazar Solicitud
			</Button>
			<MasterDialog
				{...{ open, setOpen, title: "Rechazar Vacación", handleReject, buttons }}
			>
				<Box sx={{ mb: 3 }}>
					<Typography variant="subtitle2" color="text.secondary" gutterBottom>
						Comentarios Adicionales
					</Typography>
					<TextField
						fullWidth
						multiline
						rows={3}
						placeholder="Agregue comentarios sobre el rechazo."
						value={comments}
						onChange={(e) => setComments(e.target.value)}
					/>
				</Box>
			</MasterDialog>
		</Fragment>
	)
}
